<template>
	<div class="about">
		<div class="main">
			<div class="content">
				<div class="description">
					<div class="top-mark"></div>
					<div class="description-image">
						<img :src="$pub.imageUrl+$store.state.websiteConfig.imageUrl" alt="">
					</div>
					<div class="description-richtext" v-html="$store.state.websiteConfig.richText"></div>
				</div>
				<div class="contact">
					<div class="contact-title">
						<img src="../../../assets/about-contact.png" alt="">
					</div>
					<div class="contact-map">
						<div class="map-item" v-for="(item,index) in $store.state.websiteConfig['addressList']" :key="index">
							<div class="map-title">
								<span>{{item.name}}</span>/
								{{item.address}}
							</div>
							<baidu-map class="bm-view" :center="{lng:item.lng,lat:item.lat}" :zoom="13"
								:scroll-wheel-zoom="true" @ready="handleMapReady" v-if="mapInitFlag">
								<bm-marker :position="{lng:item.lng,lat:item.lat}">
									<bm-label :content="item.name" :labelStyle="{color: 'red', fontSize : '14px'}"
										:offset="{width: -5, height: 30}" />
								</bm-marker>
								<bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT" @changeAfter="changeAfter"></bm-city-list>
								<bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
							</baidu-map>
						</div>
					</div>
				</div>
				<div class="info">
					<div class="address">
						<div class="info-title">
							<i class="el-icon-location"></i>
							公司地址
						</div>
						<ul>
							<li v-for="(item,index) in $store.state.websiteConfig['addressList']" :key="index">
								{{item.name}}:{{item.address}}
							</li>
						</ul>
					</div>
					<div class="address">
						<div class="info-title">
							<i class="el-icon-phone"></i>
							联系方式
						</div>
						<ul>
							<li v-for="(item,index) in $store.state.websiteConfig['contact']" :key="index">
								{{item.name}}:{{item.value}}
							</li>
						</ul>
					</div>
					<div class="address">
						<div class="info-title">
							<i class="el-icon-s-promotion"></i>
							交通线路
						</div>
						<ul>
							<li v-for="(item,index) in $store.state.websiteConfig['addressList']" :key="index">
								<div class="name">
									{{item.name}}
								</div>
								<div class="line" v-for="(tab,tabIndex) in item['tabs']" :key="tabIndex">
									{{tab}}
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'about',
		data() {
			return {
				mapInitFlag: false
			};
		},
		methods: {
			handleMapReady() {
				
			},
			changeAfter(e) {

			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.mapInitFlag = true
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.about {
		width: 100%;
		background: @vue-bg-color-grey;

		.main {
			width: 100%;
			margin: 0 auto;
			padding-top: 370px;
			padding-bottom: @vue-spacing-col-lg * 2;
			background: url(../../../assets/about-top.png) no-repeat;
			background-size: 100%;
		}

		.content {
			width: 1400px;
			margin: 0 auto;
			background: url(../../../assets/about-background.png);
			background-size: 100%;
			box-shadow: 0px 0px 10px @vue-border-color;
			border-radius: @vue-border-radius-lg * 2;
			overflow: hidden;
			padding: @vue-spacing-col-lg*2 @vue-spacing-row-lg*3;
			box-sizing: border-box;

			.description {
				width: 100%;
				position: relative;
				padding-top: @vue-spacing-col-lg*2;
				display: flex;
				justify-content: space-between;

				.top-mark {
					width: 40px;
					height: 8px;
					position: absolute;
					left: 50%;
					top: 0px;
					margin-left: -20px;
					background: @vue-bg-color-red;
					border-radius: 4px;
				}

				.description-image {
					width: 520px;
					height: 350px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.description-richtext {
					width: calc(100% - 550px);
					height: 100%;
				}
			}

			.contact {
				width: 100%;
				margin-top: @vue-spacing-col-lg * 2;

				.contact-title {
					width: 100%;
					height: 100px;
					text-align: center;
				}

				.contact-map {
					width: 100%;
					display: flex;
					justify-content: space-between;
					margin-top: @vue-spacing-col-lg;

					.map-item {
						width: 580px;
						height: 550px;
						background: @vue-bg-color;
						border-radius: @vue-border-radius-lg;
						box-shadow: 0px 0px 10px @vue-border-color;
						padding: 0px @vue-spacing-row-lg;
						box-sizing: border-box;

						.map-title {
							width: 100%;
							height: 100px;
							display: flex;
							align-items: center;
							justify-content: center;
							font-size: @vue-font-size-base;

							span {
								color: @vue-text-color-red;
							}
						}

						.bm-view {
							width: 100%;
							height: 420px;
						}
					}
				}
			}

			.info {
				width: 100%;
				margin-top: @vue-spacing-col-lg*2;
				box-shadow: 0px 0px 10px @vue-border-color;
				border-radius: @vue-border-radius-lg;
				padding: @vue-spacing-col-lg @vue-spacing-row-lg;
				box-sizing: border-box;
				display: flex;
				justify-content: space-between;

				.address {
					width: 33.3%;
					border-right: 1px solid @vue-border-color;
					padding: 0px @vue-spacing-row-base*2;
					box-sizing: border-box;
					
					.info-title{
						width: 100%;
						height: 50px;
						display: flex;
						align-items: center;
						font-size: @vue-font-size-sm + 2;
						
						i{
							color: @vue-text-color-red;
							font-size: 32px;
							margin-right: @vue-spacing-row-sm;
						}
					}
					
					ul{
						width: 100%;
						li{
							width: 100%;
							line-height: 36px;
							display: flex;
							align-items: center;
							font-size: @vue-font-size-min;
							color: @vue-text-color-grey;
							flex-wrap: wrap;
							
							.name{
								width: 100%;
								height: 36px;
								font-size: @vue-font-size-sm;
								color: @vue-text-color;
							}
						}
					}
				}

				.address:last-child {
					border: none;
				}
			}
		}
	}
</style>
